import { render } from "./ScreenImage.vue?vue&type=template&id=416fc20d"
import script from "./ScreenImage.vue?vue&type=script&lang=js"
export * from "./ScreenImage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__